'use client'

import { ReactSelectMenu } from '@repo/ui/ReactSelectMenu'
import { useEffect, useState } from 'react'
import { useThirdPartyCaseTypesStore } from '@repo/store/useThirdPartyCaseTypesStore'
import PropTypes from 'prop-types'

export const ThirdPartyCaseTypeSelect = ({
  label = 'Third party case type',
  required = false,
  onChange = (val: any) => {
    console.log(val)
  },
  size = 'small',
  sx = {},
  value = '',
  isEditCaseTypeMapping = false,
  testData = null
}: ThirdPartyCaseTypeSelectProps) => {
  const { newMatterDefaults, thirdPartyCaseTypesData, fetchThirdPartyCaseTypes } = useThirdPartyCaseTypesStore()
  const [options, setOptions] = useState([])
  const [selectedValue, setSelectedValue] = useState(value)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (testData) return

    setLoading(true)
    fetchThirdPartyCaseTypes({ thirdPartyService: 'perfectPortal' })
    setLoading(false)
  }, [fetchThirdPartyCaseTypes])

  useEffect(() => {
    setLoading(true)
    if (thirdPartyCaseTypesData?.length) {
      let mappedOptions
      if (!isEditCaseTypeMapping) {
        newMatterDefaults?.length > 0 && newMatterDefaults !== undefined && newMatterDefaults !== null
          ? (mappedOptions = thirdPartyCaseTypesData
              .filter(
                (item: any) =>
                  !newMatterDefaults?.some((defaultObj: any) => defaultObj.sourceWorkTypeName === item.name)
              )
              .map((id: any) => ({
                thirdPartyCaseType: id,
                label: id.name,
                value: id.id
              })))
          : (mappedOptions = thirdPartyCaseTypesData.map((id: any) => ({
              thirdPartyCaseType: id,
              label: id.name,
              value: id.id
            })))

        setOptions(mappedOptions)
      } else {
        let currentOption
        currentOption = thirdPartyCaseTypesData.find((item: any) => item.id === value)

        newMatterDefaults?.length > 0 && newMatterDefaults !== undefined && newMatterDefaults !== null
          ? (mappedOptions = thirdPartyCaseTypesData
              .filter(
                (item: any) =>
                  !newMatterDefaults?.some(
                    (defaultObj: any) => defaultObj.sourceWorkTypeName === item.name && item.id !== currentOption?.id
                  )
              )
              .map((id: any) => ({
                thirdPartyCaseType: id,
                label: id.name,
                value: id.id
              })))
          : (mappedOptions = thirdPartyCaseTypesData.map((id: any) => ({
              thirdPartyCaseType: id,
              label: id.name,
              value: id.id
            })))

        setOptions(mappedOptions)
      }
    }
    setLoading(false)
    thirdPartyCaseTypesData?.length === 0 && console.log('No third party case types found')
  }, [thirdPartyCaseTypesData])

  // Effect to map string `value` to corresponding object
  useEffect(() => {
    if (typeof value === 'string' && value) {
      const selectedOption = options.find((option: any) => option.thirdPartyCaseType.id === value) // Match by value
      if (selectedOption) {
        setSelectedValue(selectedOption)
      }
    }
  }, [value, options])

  return (
    <div data-testid="ThirdPartyCaseTypeSelect" style={{ ...sx }}>
      <ReactSelectMenu
        idLabelKey="thirdPartyCaseTypeId"
        items={options}
        label={label}
        loading={loading}
        name="thirdPartyCaseType"
        onChange={(e: any) => {
          onChange(e)
          setSelectedValue(e)
        }}
        multi={false}
        required={required}
        searchable
        showIdInResults={false}
        showSelectAll={false}
        size={size}
        value={selectedValue}
      />
    </div>
  )
}

type ThirdPartyCaseTypeSelectProps = {
  label?: string
  onChange?: (val: any) => void
  required?: boolean
  size?: 'small' | 'medium' | 'large'
  sx?: object
  value?: string
  isEditCaseTypeMapping?: boolean
  setIsEditCaseTypeMapping?: (val: any) => void
  testData?: any
}

ThirdPartyCaseTypeSelect.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  sx: PropTypes.object,
  value: PropTypes.string,
  isEditCaseTypeMapping: PropTypes.bool,
  setIsEditCaseTypeMapping: PropTypes.func,
  testData: PropTypes.any
}
